import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from '@/constants/actions';
import * as mutations from '@/constants/mutations';

// vuex modules
import MapModule from '@/store/modules/MapModule';
import SidebarModule from '@/store/modules/SidebarModule';
import ToastModule from '@/store/modules/ToastModule';
import LoadStateModule from '@/store/modules/LoadStateModule';
import NavDrawerModule from '@/store/modules/NavDrawerModule';
// install Vuex
Vue.use(Vuex);

/* eslint-disable no-param-reassign */
export default new Vuex.Store({
    modules: {
        map: MapModule,
        sidebar: SidebarModule,
        navdrawer: NavDrawerModule,
        toast: ToastModule,
        loadState: LoadStateModule,
    },
    state: {
        // promise resolved when the full-screen map is loaded
        // or set to null when no map is present on the page
        mapPromise: null,
        // alert objects with text, [color], [icon]
        alerts: [],
        // array of things that are loading
        loading: [],
        // display the chart modal
        showChartModal: false,
        chartModalActiveTab: '',

        // disable watershed clicks in order to select polygon
        selectingPolygon: false,

        // @TEMP temporary spot to store station data
        selectedStationData: null,
        selectedTableData: null,

        // @TEMP temporary spot to store filter stuff
        // names of the filters to be used on this page
        loadedFilters: [],
        // all possible options and extrema for the various filters
        filterOptions: {},
        // current filter settings
        filterSettings: {},
    },
    mutations: {
        [mutations.SET_POLYGON_SELECTING](state, selectingPolygon) {
            state.selectingPolygon = selectingPolygon;
        },
        [mutations.SET_SELECTED_STATION_DATA](state, data) {
            state.selectedStationData = data;
        },
        [mutations.SET_SELECTED_TABLE_DATA](state, data) {
            state.selectedTableData = data;
        },
        [mutations.SET_MAP_PROMISE](state, mapPromise) {
            state.mapPromise = mapPromise;
        },
        [mutations.ADD_ALERT](state, alertObj) {
            // use timestamp to add a unique id
            const timestamp = Date.now();
            alertObj.id = `alert-${timestamp}`;
            state.alerts.push(alertObj);
        },
        [mutations.REMOVE_ALERT](state, alertId) {
            state.alerts = state.alerts.filter(alert => alert.id !== alertId);
        },
        [mutations.ADD_LOADING](state, activityName) {
            state.loading.push(activityName);
        },
        [mutations.REMOVE_LOADING](state, activityName) {
            state.loading = state.loading.filter(i => i !== activityName);
        },
        [mutations.SHOW_CHART_MODAL](state, show = true) {
            state.showChartModal = show;
        },
        [mutations.SET_CHART_MODAL_TAB](state, tabName) {
            state.chartModalActiveTab = tabName;
        },
        [mutations.SET_LOADED_FILTERS](state, filters) {
            state.loadedFilters = filters;
        },
        [mutations.SET_FILTER_OPTIONS](state, options) {
            state.filterOptions = options;
        },
        [mutations.SET_FILTER_SETTINGS](state, settings) {
            state.filterSettings = settings;
        },
    },
    actions: {
        [actions.SET_SELECTED_STATION_DATA]({ commit }, data) {
            commit(mutations.SET_SELECTED_STATION_DATA, data);
        },
        [actions.SET_SELECTED_TABLE_DATA]({ commit }, data) {
            commit(mutations.SET_SELECTED_TABLE_DATA, data);
        },
        [actions.SET_MAP_PROMISE]({ commit }, mapPromise) {
            commit(mutations.SET_MAP_PROMISE, mapPromise);
        },
        [actions.ADD_ALERT]({ commit }, alertObj) {
            commit(mutations.ADD_ALERT, alertObj);
        },
        [actions.REMOVE_ALERT]({ commit }, alertId) {
            commit(mutations.REMOVE_ALERT, alertId);
        },
        [actions.ADD_LOADING]({ commit }, activityName) {
            commit(mutations.ADD_LOADING, activityName);
        },
        [actions.REMOVE_LOADING]({ commit }, activityName) {
            commit(mutations.REMOVE_LOADING, activityName);
        },
        [actions.SHOW_CHART_MODAL]({ commit }, show = true) {
            commit(mutations.SHOW_CHART_MODAL, show);
        },
        [actions.SET_CHART_MODAL_TAB]({ commit }, tabName) {
            commit(mutations.SET_CHART_MODAL_TAB, tabName);
        },
        [actions.SET_LOADED_FILTERS]({ commit }, filters) {
            commit(mutations.SET_LOADED_FILTERS, filters);
        },
        [actions.SET_FILTER_OPTIONS]({ commit }, options) {
            commit(mutations.SET_FILTER_OPTIONS, options);
        },
        [actions.SET_FILTER_SETTINGS]({ commit }, settings) {
            commit(mutations.SET_FILTER_SETTINGS, settings);
        },
        // unload and reset filters
        [actions.UNLOAD_FILTERS]({ commit }) {
            commit(mutations.SET_LOADED_FILTERS, []);
            commit(mutations.SET_FILTER_OPTIONS, {});
            commit(mutations.SET_FILTER_SETTINGS, {});
        },
    },
});



// WEBPACK FOOTER //
// ./src/store/store.js